var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTapsiBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.319,
    height: 22.284,
    viewBox: "0 0 103.319 22.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.886,29.846h-3.263v4.336h-7.069V29.846h-3.263v4.336h-5.71a1.9,1.9,0,0,1-1.9-1.9V29.846h-3.263v2.439a1.9,1.9,0,0,1-3.806,0V29.846h-3.263v2.439a1.9,1.9,0,0,1-1.9,1.9h-1.9V29.846h-3.263v4.336h-17.4v3.253h3.806v.542a4.894,4.894,0,0,1-9.788,0V34.183h-3.263v3.794a8.157,8.157,0,0,0,16.314,0v-.542h15.5a5.155,5.155,0,0,0,3.535-1.4,5.165,5.165,0,0,0,7.069,0,5.155,5.155,0,0,0,3.534,1.4h19.3Z",
    transform: "translate(-150.567 -23.823)",
    fill: "#d8d8d8",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M425.17,83.87h3.9v2.737h3.347V80.585h-7.25Z",
    transform: "translate(-339.373 -64.323)",
    fill: "#d8d8d8",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M485.71,0h-6.646V3.011h6.646Z",
    transform: "translate(-382.391)",
    fill: "#d8d8d8",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.208,35.267H53.895V29.846H70.208Z",
    transform: "translate(-43.019 -23.823)",
    fill: "#d8d8d8",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.189,88.99H0V83.57H27.189Z",
    transform: "translate(0 -66.706)",
    fill: "#d8d8d8",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapsiBlack);
export default __webpack_public_path__ + "static/media/tapsi_black.ca3dc3afa590f380399445f0f570aa92.svg";
export { ForwardRef as ReactComponent };